var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentacleProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 704,
    viewBox: "0 0 309 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_7448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 309,
    height: 704
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 704,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_7448)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_7448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.453 165.961C141.8 160.446 148.172 137.834 155.635 116.668C163.099 95.5015 215.655 85.8239 227.228 103.022C238.621 119.943 193.456 109.979 189.684 124.035C187.668 131.554 193.685 142.641 217.048 142.094C244.84 141.451 248.391 122.229 249.336 107.84C250.278 93.4399 222.893 72.906 198.564 68.34C174.236 63.774 128.71 81.0515 115.099 102.928C101.487 124.805 89.7674 178.042 90.6648 233.158C91.5588 288.281 108.096 364.898 74.0943 519.803C40.0925 674.707 -57.3311 764.454 -100.067 793.759C-107.036 798.543 -115.272 801.412 -124.179 802.888L-238.754 744.903L-242.453 721.699C-242.453 721.699 -224.633 716.567 -215.541 713.641C-206.449 710.716 -149.62 696.18 -132.37 689.654C-115.112 683.132 -29.3517 631.47 -12.7527 598.988C3.84637 566.506 21.789 522.899 41.8423 448.177C61.9024 373.458 36.5344 300.769 30.7601 257.04C24.9858 213.311 55.569 132.822 76.2968 91.8645C97.0246 50.9073 108.646 42.9838 124.998 23.2111C141.35 3.43833 190.646 35.6007 190.646 35.6007C190.646 35.6007 272.51 70.1031 282.686 77.5566C292.868 85.0136 280.713 151.632 271.149 164.546C261.581 177.466 197.104 171.466 169.457 165.954L169.453 165.961Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.453 165.961C141.8 160.446 148.172 137.834 155.635 116.668C163.099 95.5015 215.655 85.8239 227.228 103.022C238.621 119.943 193.456 109.979 189.684 124.035C187.668 131.554 193.685 142.641 217.048 142.094C244.84 141.451 248.391 122.229 249.336 107.84C250.278 93.4399 222.893 72.906 198.564 68.34C174.236 63.774 128.71 81.0515 115.099 102.928C101.487 124.805 89.7674 178.042 90.6648 233.158C91.5588 288.281 108.096 364.898 74.0943 519.803C40.0925 674.707 -57.3311 764.454 -100.067 793.759C-107.036 798.543 -115.272 801.412 -124.179 802.888L-238.754 744.903L-242.453 721.699C-242.453 721.699 -224.633 716.567 -215.541 713.641C-206.449 710.716 -149.62 696.18 -132.37 689.654C-115.112 683.132 -29.3517 631.47 -12.7527 598.988C3.84637 566.506 21.789 522.899 41.8423 448.177C61.9024 373.458 36.5344 300.769 30.7601 257.04C24.9858 213.311 55.569 132.822 76.2968 91.8645C97.0246 50.9073 108.646 42.9838 124.998 23.2111C141.35 3.43833 190.646 35.6007 190.646 35.6007C190.646 35.6007 272.51 70.1031 282.686 77.5566C292.868 85.0136 280.713 151.632 271.149 164.546C261.581 177.466 197.104 171.466 169.457 165.954L169.453 165.961Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.153 186.949C116.755 169.55 129.022 110.548 177.149 92.1656C213.122 78.4243 227.231 103.015 227.231 103.015C227.231 103.015 163.136 80.8718 162.131 135.312C161.824 152.008 222.067 181.196 257.797 130.938C293.526 80.68 191.328 17.1459 123.638 66.1815C55.4642 115.572 82.8892 229.232 48.4687 442.62C18.7454 626.869 -131.566 730.767 -195.056 767.035L-296.015 715.941C-296.096 699.311 -286.492 683.286 -270.288 675.927C-236.847 660.736 -185.152 632.953 -141.982 591.034C-22.4231 474.923 -19.0498 300.273 -2.10148 204.176C31.8195 11.8326 106.05 10.3815 154.007 6.17325C201.974 1.96165 287.477 40.8622 298.845 85.7429C317.035 157.576 275.548 204.355 196.153 186.949Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 11.34,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.153 186.949C116.755 169.55 129.022 110.548 177.149 92.1656C213.122 78.4243 227.231 103.015 227.231 103.015C227.231 103.015 163.136 80.8718 162.131 135.312C161.824 152.008 222.067 181.196 257.797 130.938C293.526 80.68 191.328 17.1459 123.638 66.1815C55.4642 115.572 82.8892 229.232 48.4687 442.62C18.7454 626.869 -131.566 730.767 -195.056 767.035L-296.015 715.941C-296.096 699.311 -286.492 683.286 -270.288 675.927C-236.847 660.736 -185.152 632.953 -141.982 591.034C-22.4231 474.923 -19.0498 300.273 -2.10148 204.176C31.8195 11.8326 106.05 10.3815 154.007 6.17325C201.974 1.96165 287.477 40.8622 298.845 85.7429C317.035 157.576 275.548 204.355 196.153 186.949Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.413 181.472C267.397 182.012 266.348 182.519 265.288 183.012C266.487 182.294 267.516 181.794 268.413 181.472Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.153 186.949C126.455 171.675 127.399 124.342 161.225 100.57C154.694 114.926 148.958 134.797 158.618 148.039C173.586 168.55 226.335 193.271 256.153 186.54C239.855 191.633 219.667 192.107 196.15 186.956L196.153 186.949Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-269.47 729.366L-295.991 715.945C-296.079 699.311 -286.482 683.283 -270.278 675.924C-236.837 660.733 -185.142 632.95 -141.972 591.031C-22.4096 474.913 -19.0397 300.27 -2.09141 204.172C18.1773 89.2422 52.8393 42.4772 87.684 22.5451C52.1664 59.6964 24.4053 124.839 23.1912 186.962C20.8827 305.268 24.8756 430.882 -40.4496 539.27C-89.166 620.109 -168.25 706.413 -269.463 729.37L-269.47 729.366Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.8988 705.781C-54.9376 694.617 -54.6808 664.094 -37.3252 637.605C-19.9696 611.117 7.91249 598.694 24.9513 609.858C41.99 621.022 41.7332 651.545 24.3776 678.034C7.02207 704.522 -20.86 716.945 -37.8988 705.781Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7408 671.496C6.89092 685.623 -8.25298 691.637 -17.0993 684.924C-25.9389 678.215 -25.1262 661.319 -15.2763 647.192C-5.42646 633.065 9.71745 627.05 18.5638 633.764C27.4034 640.473 26.5907 657.368 16.7408 671.496Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1486 547.774C33.193 521.949 54.8033 506.252 71.4167 512.714C88.03 519.176 93.3551 545.349 83.3107 571.174C73.2663 596.999 51.6559 612.696 35.0426 606.234C18.4293 599.772 13.1042 573.599 23.1486 547.774Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3381 553.125C48.8035 539.073 60.5601 530.531 69.5972 534.046C78.6343 537.561 81.5299 551.802 76.0645 565.853C70.5992 579.905 58.8426 588.447 49.8054 584.932C40.7683 581.417 37.8728 567.176 43.3381 553.125Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4639 447.468C59.4824 420.141 76.1787 399.562 93.7561 401.503C111.334 403.445 123.136 427.172 120.117 454.499C117.099 481.826 100.403 502.405 82.8252 500.463C65.2478 498.522 53.4454 474.795 56.4639 447.468Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.644 452.476C109.579 467.277 100.217 477.889 90.7373 476.179C81.254 474.46 75.2482 461.067 77.3067 446.262C79.3718 431.46 88.7332 420.849 98.2133 422.558C107.697 424.278 113.702 437.671 111.644 452.476Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61 352.06C119.943 375.72 107.999 393.834 93.9349 392.513C79.8704 391.192 69.0056 370.944 69.6726 347.284C70.3397 323.623 82.2831 305.509 96.3476 306.83C110.412 308.151 121.277 328.399 120.61 352.06Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.772 349.064C113.41 361.934 106.911 371.792 99.2579 371.074C91.6047 370.357 85.6951 359.342 86.0607 346.464C86.4228 333.594 92.922 323.736 100.575 324.454C108.228 325.171 114.138 336.186 113.772 349.064Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5977 259.539C69.5131 238.456 77.2593 220.432 88.8992 219.281C100.539 218.13 111.665 234.288 113.75 255.371C115.834 276.454 108.088 294.477 96.448 295.628C84.8081 296.779 73.6822 280.621 71.5977 259.539Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.064 255.785C108.749 267.27 104.118 276.437 97.7217 276.254C91.3252 276.071 85.5831 266.609 84.8982 255.124C84.2132 243.639 88.8436 234.473 95.2401 234.655C101.637 234.838 107.379 244.3 108.064 255.785Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.43 182.187C81.2845 166.726 88.897 154.575 97.4329 155.047C105.969 155.519 112.196 168.435 111.342 183.896C110.487 199.357 102.875 211.508 94.3387 211.036C85.8027 210.565 79.5756 197.649 80.43 182.187Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.179 183.571C106.384 191.945 102.021 198.048 97.4221 197.197C92.8234 196.347 89.7351 188.877 90.5232 180.5C91.3181 172.127 95.6811 166.024 100.28 166.874C104.878 167.725 107.967 175.194 107.179 183.571Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.794 147.456C89.2677 143.402 89.1201 129.064 96.4644 115.431C103.809 101.799 115.864 94.035 123.39 98.0897C130.916 102.144 131.064 116.483 123.719 130.115C116.375 143.747 104.32 151.511 96.794 147.456Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.098 128.064C115.824 135.31 109.277 138.975 105.476 136.249C101.674 133.524 102.057 125.448 106.331 118.203C110.605 110.957 117.152 107.292 120.953 110.018C124.755 112.743 124.372 120.819 120.098 128.064Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.172 89.3136C142.255 97.1377 131.096 98.7131 127.252 92.8358C123.409 86.9585 128.328 75.8543 138.245 68.0302C148.162 60.2062 159.321 58.6308 163.165 64.5081C167.008 70.3854 162.089 81.4896 152.172 89.3136Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.261 85.6459C145.866 89.9026 139.795 90.762 137.702 87.5599C135.607 84.3645 138.286 78.3202 143.68 74.0635C149.075 69.8068 155.147 68.9473 157.239 72.1495C159.334 75.3449 156.655 81.3892 151.261 85.6459Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.842 74.2289C177.785 73.5186 169.582 68.0006 170.521 61.9108C171.46 55.821 181.175 51.464 192.232 52.1743C203.289 52.8846 211.491 58.4026 210.553 64.4924C209.614 70.5822 199.893 74.9357 188.842 74.2289Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.405 71.3071C184.39 70.921 179.926 67.9195 180.437 64.6088C180.948 61.2981 186.233 58.9264 192.248 59.3125C198.263 59.6986 202.726 62.7002 202.215 66.0109C201.704 69.3215 196.42 71.6932 190.405 71.3071Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.673 91.6874C216.798 82.6981 214.002 71.782 219.415 67.3065C224.827 62.8311 236.416 66.4934 245.281 75.4861C254.147 84.4788 256.952 95.3915 251.54 99.867C246.127 104.342 234.539 100.68 225.673 91.6874Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.212 90.3814C224.387 85.4925 222.864 79.549 225.808 77.1155C228.753 74.6819 235.053 76.6722 239.884 81.5644C244.709 86.4532 246.233 92.3967 243.288 94.8302C240.344 97.2638 234.043 95.2736 229.212 90.3814Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.605 117.63C244.848 108.572 251.417 103.045 256.275 105.284C261.132 107.523 262.445 116.684 259.199 125.75C255.956 134.808 249.387 140.335 244.529 138.096C239.671 135.857 238.359 126.696 241.605 117.63Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.673 119.63C245.441 114.703 249.014 111.693 251.655 112.912C254.296 114.13 255.012 119.116 253.244 124.044C251.476 128.971 247.902 131.981 245.262 130.763C242.621 129.545 241.905 124.558 243.673 119.63Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36 133.264C233.98 133.382 241.349 137.794 240.808 143.115C240.274 148.439 232.037 152.659 222.415 152.548C212.796 152.43 205.427 148.017 205.968 142.697C206.502 137.373 214.738 133.153 224.36 133.264Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.142 135.871C228.378 135.93 232.387 138.33 232.093 141.228C231.799 144.125 227.32 146.423 222.088 146.358C216.853 146.299 212.844 143.899 213.138 141.001C213.431 138.103 217.91 135.805 223.142 135.871Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.69 133.293C200.126 141.867 198.916 151.178 192.983 154.082C187.049 156.986 178.651 152.389 174.214 143.815C169.778 135.242 170.988 125.931 176.921 123.027C182.855 120.123 191.253 124.719 195.69 133.293Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.337 133.866C194.752 138.531 194.094 143.599 190.864 145.179C187.634 146.759 183.067 144.262 180.656 139.591C178.241 134.926 178.898 129.858 182.128 128.278C185.358 126.698 189.925 129.194 192.337 133.866Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35 122.911C189.843 123.305 183.622 119.457 183.472 114.318C183.322 109.179 189.273 104.689 196.78 104.295C204.287 103.9 210.508 107.749 210.658 112.888C210.808 118.026 204.857 122.516 197.35 122.911Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 2.83,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.015 120.345C193.934 120.557 190.546 118.463 190.466 115.672C190.378 112.877 193.622 110.434 197.704 110.222C201.786 110.009 205.173 112.103 205.254 114.895C205.342 117.69 202.097 120.132 198.015 120.345Z",
    fill: "#F7C6CF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_7448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287.106,
    height: 864.856,
    fill: "white",
    transform: "matrix(-0.892245 -0.451551 -0.451551 0.892245 340.695 73.6429)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentacleProducts);
export default __webpack_public_path__ + "static/media/tentacle_products.b0a9e17499c0e54bb5120470632227f7.svg";
export { ForwardRef as ReactComponent };